const Payments = [
  {
    id: 'mpesa_paybill',
    name: 'MPESA PAYBILL',
  },
  {
    id: 'momo',
    name: 'MTN MOMO',
  },
  {
    id: 'co-op',
    name: 'CO-OP BANK',
  },
  {
    id: 'ncba',
    name: 'NCBA BANK',
  },
];

export default Payments;
